import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Assets from "@/pages/Assets";
import AssetForm from "@/pages/AssetForm";
import AssetDetail from "@/pages/AssetDetail";
import Categories from "@/pages/Categories";
import AccountingView from "@/pages/AccountingView";
import AuditLog from "@/pages/AuditLog";
import Admin from "@/pages/Admin";
import Licenses from "@/pages/Licenses";
import AdobeLicenses from "@/pages/AdobeLicenses";
import Security from "@/pages/Security";
import Software from "@/pages/Software";
import Forms from "@/pages/Forms";
import FormRun from "@/pages/FormRun";
import ServiceWork from "@/pages/ServiceWork";
import HawkeEye from "@/pages/HawkeEye";
import Backups from "@/pages/Backups";
import Notebook from "@/pages/Notebook";
import DRPlan from "@/pages/DRPlan";
import Documentation from "@/pages/Documentation";
import SiteDocs from "@/pages/SiteDocs";
import LinksInfo from "@/pages/LinksInfo";

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="bottom-right"
            theme="light"
            toastOptions={{
              style: {
                background: "#0a0a0a",
                border: "1px solid #222",
                borderRadius: 0,
                fontFamily: "IBM Plex Mono, monospace",
                fontSize: 12,
                color: "#fff",
              },
            }}
          />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/assets" element={<Assets />} />
              <Route path="/assets/new" element={<AssetForm />} />
              <Route path="/assets/:id" element={<AssetDetail />} />
              <Route path="/assets/:id/edit" element={<AssetForm />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/software" element={<Software />} />
              <Route path="/backups" element={<Backups />} />
              <Route path="/notebook" element={<Notebook />} />
              <Route path="/dr-plan" element={<DRPlan />} />
              <Route path="/documentation" element={<Documentation />} />
              <Route path="/site-docs" element={<SiteDocs />} />
              <Route path="/links-info" element={<LinksInfo />} />
              <Route path="/forms" element={<Forms />} />
              <Route path="/forms/new/:slug" element={<FormRun />} />
              <Route path="/forms/:id" element={<FormRun />} />
              <Route path="/service-work" element={<ServiceWork />} />
              <Route path="/hawke-eye" element={<HawkeEye />} />
              <Route path="/accounting" element={<AccountingView />} />
              <Route path="/audit" element={<AuditLog />} />
              <Route path="/licenses" element={<Licenses />} />
              <Route path="/adobe-licenses" element={<AdobeLicenses />} />
              <Route path="/security" element={<Security />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
